import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import Button from '@/components/Button'
import Card from '@/components/Card'
import { Plus } from '@/components/Icons'
import { Column, Row } from '@/components/StyledComponents'
import useFeatures from '@/components/useFeatures'
import { CHANNEL_CONNECTIONS_OIDC } from '@/constants/featureToggles'
import sharedMessages from '@/pages/OrganizationChannelConnectionsPage/messages'

import messages from './messages'

const StyledCard = styled(Card)`
  padding: 3rem 2rem 2rem 2rem;
`

const StyledRow = styled(Row)`
  padding-top: 1.5rem;
`

const StyledColumnHelpDocumentation = styled(Column)`
  margin-left: 2.5rem;
`

const StyledLink = styled.a`
  margin-left: 0.25rem;
  font-size: 13px;
`

interface LandingPageProps {
  onCreateChannel: () => void
}

const ChannelConnectionsLandingPage = ({ onCreateChannel }: LandingPageProps) => {
  const features = useFeatures()
  const showCreateButton = !!features[CHANNEL_CONNECTIONS_OIDC]
  return (
    <StyledCard>
      <div className="min-w-0 flex-1">
        <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
          <FormattedMessage {...messages.pageTitle} />
        </h2>
      </div>
      <StyledRow>
        <Column>
          <h3 className="text-xl leading-10 text-gray-700">
            <FormattedMessage {...messages.header} />
          </h3>
          <p className="mt-2 max-w-xl text-sm text-gray-500">
            <FormattedMessage {...messages.subHeader} />
          </p>
        </Column>
        <StyledColumnHelpDocumentation>
          <p>
            <FormattedMessage {...sharedMessages.needHelpDescription} />
            <StyledLink
              href={'https://help.workgrid.com/s/article/Understanding-Platforms-and-Devices'}
              rel="noopener noreferrer"
              target="_blank"
            >
              <FormattedMessage {...sharedMessages.needHelpLink} />
            </StyledLink>
          </p>
        </StyledColumnHelpDocumentation>
      </StyledRow>
      <StyledRow>
        <Column>
          {showCreateButton && (
            <Button color="primary" onClick={onCreateChannel}>
              <Plus />
              <FormattedMessage {...messages.createChannelConnectionButton} />
            </Button>
          )}
        </Column>
      </StyledRow>
    </StyledCard>
  )
}

export default ChannelConnectionsLandingPage
